import React, { Component } from 'react';
import strings from '../locales/';

const BottomTableButtons = props =>
  (
    <div className={"bottom-table-buttons " + props.className}>
      <div className="actions-container">
        <div className="actions-inner-container">
          <div className="left-button-container">
            <div className={"box-form"}>
              <div className={'normal_button'} onClick={props.handleSendFlows}>
                <div>{"Enviar"}</div>
              </div>
            </div>
          </div>    
        </div>      
      </div>
    </div>
  );

export default BottomTableButtons;



// WEBPACK FOOTER //
// ./source/client/components/flow_applicant_detail/bottomTableButtons.jsx